//separated this file from axios file 
//because in interceptor we are using store and 
//when we keep same file it cause reducers to register late 
//and console shows error   
import axios from './axios';
import { axiosNT, axiosNL, axiosNTL, axiosNS, singleUserAxios } from './axios';
import { ServerAlertAction, LoaderAction } from '../components/common';
import config from '../config/config';
import { ServerAlertActionV2 } from '../components/common/types/ServerAlertActionV2';
import { VARIANT } from '../components/common/types/ServerAlertDataV2';

const axiosInterceptor = (dispatch:any) => {
    let netConnmsg = "Internet Disconnected";
    //action function
    function showAlert(message : string, variant : 'error'|'success' = 'error') : ServerAlertAction {
        return { type: 'SHOW_ALERT', data: {message: message, variant: variant, openSnackbar: true}};
    }

    //Action alert for single sign on
    function showAlertLogin(message : string, variant : VARIANT = VARIANT.LOGIN_ERROR) : ServerAlertActionV2 {
      if (message.includes('Login')) {
        message = 'Logged in successfully';
      }
      return showAlertV2(message,variant);
    }

    function showAlertV2(message : string, variant:VARIANT=VARIANT.SUCCESS,title='') : ServerAlertActionV2 {
      return { type: 'SHOW_ALERT', data: {message: message, variant: variant, openSnackbarV2: true,title}};
    }
    
    function showLoader() : LoaderAction {
        return { type: 'SHOW_LOADER'};
    }
    function hideLoader() : LoaderAction {
        return { type: 'HIDE_LOADER'};
    }

    //request interceptors
    function commonRequest(request : any){
      try{
        let store: any = localStorage.getItem(config.localStorageKey) || localStorage.getItem('tempAuthToken');
        store = JSON.parse(store);
        let token = store.authenticatedUser.token;
        token = !token ? store.authenticatedUser.authToken : token;
        if (request.url.endsWith('v4/auth/password') && store.authenticatedUser.teachersAuthToken) {
          token = store.authenticatedUser.teachersAuthToken;
          request.headers = {
            'Content-type': 'application/json; charset=UTF-8',
            'Authorization': token,
            'origin': `${window.location.href}`
          };
        } else {
          request.headers['Authorization'] =  `Bearer ${token}`;
          request.headers['roleselected'] =  store.selectedRoleIndex;
        }
        

      }catch(ex){

      }
      return request;
    }

    function commonResponse(response: any){
      if(!response){
        dispatch(showAlert("Server Error"));
        return;
      }
      //got response 401
      if(response.status == 401 || (response.data && response.data.statusCode == 401)){
        localStorage.clear();
        location.reload();
      }
    }

    axios.interceptors.request.use( (request) => {
      //show loader
      dispatch(showLoader());


      request = commonRequest(request);
      return request
    });

    singleUserAxios.interceptors.request.use( (request) => {
      //show loader
      dispatch(showLoader());


      request = commonRequest(request);
      return request
    });

    axiosNT.interceptors.request.use( (request) => {
      //show loader
      dispatch(showLoader());

      request = commonRequest(request);
      return request
    });
    axiosNL.interceptors.request.use( (request) => {
      request = commonRequest(request);
      return request
    })
    axiosNTL.interceptors.request.use( (request) => {
      request = commonRequest(request);
      return request
    })

    axiosNS.interceptors.request.use( (request) => {
      //show loader
      dispatch(showLoader());


      request = commonRequest(request);
      return request
    });

    
    //response interceptors
    axios.interceptors.response.use( (response) => {
      //hide loader
      dispatch(hideLoader());
      commonResponse(response);

        //got response success
        if(response.status == 400 || response.data.statusCode == 400 || response.data.statusCode == 423){
          dispatch(showAlert(response.data.responseMessage));
          return Promise.reject("");
        }
      
        //got response success
        if (response.data.statusCode === 200) {
          if (response.request.responseURL.endsWith('note/')) {
          dispatch(showAlertV2(response.data.responseMessage, VARIANT.SUCCESS, 'Updated Successfully'));
        }
          else if (response.request.responseURL.includes('/note')) {
            dispatch(showAlertV2(response.data.responseMessage, VARIANT.SUCCESS, 'Created Successfully'));
          }
        else if (response.request.responseURL.includes('/publishContent/')) {
          dispatch(showAlertV2(response.data.responseMessage, VARIANT.SUCCESS, 'Published Successfully'));
        } else if (response.request.responseURL.includes('/content-validation') && !response.request.responseURL.includes('/publish-before-validation')) {
          return response.data;
        }
        else {
          if ('Content Sub Type created successfully' == response.data.responseMessage) {
            response.data.responseMessage = 'Test Type created successfully'
          }
          dispatch(showAlert(response.data.responseMessage, 'success'));
        }
      }
      
        if(response.data.statusCode == 500 || response.data.statusCode == 422){
          dispatch(showAlert(response.data.responseMessage, 'error'));
        }
      
        // Do something with response data
        return response.data;
      }, (error) => {
        //hide loader
        dispatch(hideLoader());
        if(!window.navigator.onLine){
          dispatch(showAlert(netConnmsg));
          return;
        }
        commonResponse(error.response);
        
        
        
        try{
          if(error.response.status == 404){
            dispatch(showAlert("Not found"));
          }
          else if(error.data.responseMessage){
            dispatch(showAlert(error.data.responseMessage));
          }else{
            dispatch(showAlert("Something went wrong..."));
          }
        }catch(ex){}
      
        // Do something with response error
        return Promise.reject(error);
      });

      //response interceptors
    singleUserAxios.interceptors.response.use( (response) => {
      //hide loader
      dispatch(hideLoader());
      commonResponse(response);
      
      if(response.data.code === 422 && response.request.responseURL.endsWith('/verify-otp')){
        dispatch(showAlertLogin(response.data.message,VARIANT.LOGIN_ERROR));
        return response.data;
      }
        //got response success
        if(response.status == 400 || response.data.code == 400 || response.data.code == 423 || response.data.code == 404 || response.data.code === 403){

          if (!response.request.responseURL.endsWith('/verify-otp') && !response.request.responseURL.endsWith('/login')){
            dispatch(showAlertLogin(response.data.message, VARIANT.LOGIN_ERROR));
          }
          return Promise.reject("");
        }
      
      
        //got response success
        if(response.data.code == 200 && !(response.request.responseURL.endsWith('/show-captcha') || response.request.responseURL.endsWith('/user-devices/verify-otp') || response.request.responseURL.lastIndexOf('/verify-user?id=') != -1) && response.data.message !== 'Successfully removed user device'){
          dispatch(showAlertLogin(response.data.message,VARIANT.LOGIN_SUCCESS));
        }
      
        if(response.data.code == 500){
          dispatch(showAlertLogin(response.data.message, VARIANT.LOGIN_ERROR));
        }
      
        // Do something with response data
        return response.data;
      }, (error) => {
        //hide loader
        dispatch(hideLoader());
        if(!window.navigator.onLine){
          dispatch(showAlertLogin(netConnmsg));
          return;
        }
        commonResponse(error.response);
        
        
        
        try{
          if(error.response.status == 404 || error.response.code == 404){
            dispatch(showAlertLogin("Not found"));
          }
          else if(error.data.message){
            dispatch(showAlertLogin(error.data.essage));
          }else{
            dispatch(showAlertLogin("Something went wrong..."));
          }
        }catch(ex){}

        if (error.response.request.responseURL.endsWith('/verify-otp')){
          return {};
        }
      
        // Do something with response error
        return Promise.reject(error);
      });

    axiosNS.interceptors.response.use( (response) => {
      //hide loader
      dispatch(hideLoader());
      commonResponse(response);

        //got response success
        if(response.status == 400 || response.data.statusCode == 400 || response.data.statusCode == 423){
          dispatch(showAlert(response.data.responseMessage));
          return Promise.reject("");
        }
      
      
        if(response.data.statusCode == 500 || response.data.statusCode === 422){
          dispatch(showAlert(response.data.responseMessage, 'error'));
        }
      
        // Do something with response data
        return response.data;
      }, (error) => {
        //hide loader
        dispatch(hideLoader());
        if(!window.navigator.onLine){
          dispatch(showAlert(netConnmsg));
          return;
        }
        commonResponse(error.response);
        
        
        
        try{
          if(error.response.status == 404){
            dispatch(showAlert("Not found"));
          }
          else if(error.data.responseMessage){
            dispatch(showAlert(error.data.responseMessage));
          }else{
            dispatch(showAlert("Something went wrong..."));
          }
        }catch(ex){}
      
        // Do something with response error
        return Promise.reject(error);
      });

      
      
      
      axiosNT.interceptors.response.use( (response) => {
        //hide loader
        dispatch(hideLoader());
        commonResponse(response);

        //got response success
        if(response.status == 400 || response.data.statusCode == 400 || response.data.status == 422 || response.data.statusCode == 422){
          dispatch(showAlert(response.data.responseMessage));
          // return Promise.reject("");
        }
      
        // Do something with response data
        return response.data;
      }, (error) => {
        //hide loader

        dispatch(hideLoader());
        if(!window.navigator.onLine){
          dispatch(showAlert(netConnmsg));
          return;
         }
        commonResponse(error.response);
        
          // dispatch(showAlert("Something went wrong..."));
      
        // Do something with response error
        return Promise.reject(error);
      });

      axiosNL.interceptors.response.use( (response) => {
        commonResponse(response);

        //got response success
        if(response.status == 400 || response.data.statusCode == 400){
          dispatch(showAlert(response.data.responseMessage));
          return Promise.reject("");
        }
      
        //got response success
        if(response.data.statusCode == 200){
          dispatch(showAlert(response.data.responseMessage, 'success'));
        }
      
      
        // Do something with response data
        return response.data;
      }, (error) => {

          dispatch(hideLoader());
          if(!window.navigator.onLine){
            dispatch(showAlert(netConnmsg));
            return;
           }
          commonResponse(error.response);
          
          dispatch(showAlert("Something went wrong..."));
        // Do something with response error
        return Promise.reject(error);
      }); 

      axiosNTL.interceptors.response.use( (response) => {
        commonResponse(response);
      
        // Do something with response data
        return response.data;
      }, (error) => {
        dispatch(hideLoader());
        if(!window.navigator.onLine){
          dispatch(showAlert(netConnmsg));
          return;
         }
        commonResponse(error.response);
        
        // Do something with response error
        return Promise.reject(error);
      }); 

}


export default axiosInterceptor;